import { Card, Flex, Icon, Text } from "components/common"
import { IconText } from "components/custom"
import { useTranslation } from "react-i18next"
import { localisedValue } from "utils"
import theme from "utils/themeVars"

const QuickHighlights = ({ insights }) => {
  const { t } = useTranslation()

  if (!insights || !Array.isArray(insights) || insights.length === 0) return null

  const validInsights = insights.filter(insight => insight && typeof insight === "object")
  if (validInsights.length === 0) return null

  return (
    <Card Shadow={false} variant="gradient" className="w-100" bodyStyle={{ padding: "16px" }}>
      <IconText
        className="mbe-12"
        icon="BsStars"
        iconProps={{ size: 20, style: { color: theme["accent-color"] } }}
        title={
          <Text strong className="fs16">
            {t("Quick Highlights")}
          </Text>
        }
      />
      <Flex vertical gap="10px" align="start">
        {validInsights.map((insight, index) => {
          const title = localisedValue({ object: insight, key: "title" }) || ""
          const description = localisedValue({ object: insight, key: "description" }) || ""

          if (!title && !description) return null

          return (
            <Flex key={index} gap="10px" align="start" wrap={false}>
              <Icon icon="LuDiamond" size={14} style={{ color: theme["accent-color"], flexShrink: 0, marginTop: 6 }} />

              <div>
                <span className="semiBold base-color">{title}:</span>
                <span className="fw-medium  gray-900" style={{ marginInlineStart: "4px" }}>
                  {description}
                </span>
              </div>
            </Flex>
          )
        })}
      </Flex>
    </Card>
  )
}

export default QuickHighlights
